import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { NotificationService, NOTIFICATION_TYPE_ERROR, NOTIFICATION_DURATIONS } from 'ui-components/services/notification-service';

import { addressPropType } from '../../../../../../../address/address-fields/address-prop-type';
import addressMessages from '../../../../../../../components/address-validation/messages';
import { validateAndUpdateAddress } from '../../../../../../../fulfillment-plans/fulfillment-plans.api';
import { useUpdateEntitiesFulfillmentPlans } from '../../../../../hooks/use-update-entities-fulfillment-plans';
import messages from '../messages';

import style from '../address.module.less';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

const ValidateButton = ({ shipTo, fulfillmentPlanId, isShippedStatus = false }) => {
  const updateEntities = useUpdateEntitiesFulfillmentPlans();
  const onClick = useCallback(async () => {
    try {
      const { data } = await validateAndUpdateAddress({
        shipTo,
        fulfillmentPlanIds: [fulfillmentPlanId],
        validateAddress: true,
      });
      updateEntities(data);
    } catch {
      NotificationService.showNotification({
        notificationType: NOTIFICATION_TYPE_ERROR,
        title: <FormattedMessage {...messages.validationErrorTitle} />,
        content: <FormattedMessage {...messages.validationErrorMessage} />,
        duration: NOTIFICATION_DURATIONS.SHORT,
      });
    }
  }, [fulfillmentPlanId, shipTo, updateEntities]);
  if (isShippedStatus) {
    return null;
  }

  return (
    <div className={style.validate}>
      <Button className={buttonTextStyle['button-text']} onClick={onClick} theme='link'>
        <FormattedMessage {...addressMessages.validateAddress} />
      </Button>
    </div>
  );
};

ValidateButton.propTypes = {
  shipTo: addressPropType.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
  isShippedStatus: PropTypes.bool,
};

export { ValidateButton };
